import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search) => {
  return await GET(
    `/admin/matka/store?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}`,{},process.env.REACT_APP_MATKA_BASE_URL
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/matka/store/${id}`,{},process.env.REACT_APP_MATKA_BASE_URL);
};

export const Create = async (data) => {
  return await POST(`/admin/matka/store`, data,process.env.REACT_APP_MATKA_BASE_URL);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/matka/store/${id}`, data,process.env.REACT_APP_MATKA_BASE_URL);
};

export const UpdateTiming = async (id, data) => {
  return await PUT(`/admin/matka/store-timing/${id}`, data,process.env.REACT_APP_MATKA_BASE_URL);
};

export const Status = async (id) => {
  return await POST(`/admin/matka/store/${id}`, {},process.env.REACT_APP_MATKA_BASE_URL);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/matka/store/${id}`,process.env.REACT_APP_MATKA_BASE_URL);
};
